import { render } from "./BarGameTrainingAvgChart.vue?vue&type=template&id=55919f0b"
import script from "./BarGameTrainingAvgChart.vue?vue&type=script&lang=js"
export * from "./BarGameTrainingAvgChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__